import { IResponse } from "models";

export enum ActionType {
  GET_QUESTIONNAIRES_DETAIL = "action/GET_QUESTIONNAIRES_DETAIL",
  GET_QUESTIONNAIRES_DETAIL_SUCCESS = "action/GET_QUESTIONNAIRES_DETAIL_SUCCESS",
  GET_QUESTIONNAIRES_DETAIL_ERROR = "action/GET_QUESTIONNAIRES_DETAIL_ERROR",
  GET_QUESTIONNAIRES_DETAIL_RESET = "action/GET_QUESTIONNAIRES_DETAIL_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface QuestionnaireAnswer {
  link_questionnaire_question_id: any;
  link_questionnaire_question?: any;
  id: number;
  is_other?: boolean;
  answer_text: string;
  _destroy?: boolean;
}

export interface QuestionnairesQuestion {
  id: number;
  answer_type: string;
  question_content: string;
  question_summary: string;
  is_free_text: boolean;
  is_required: boolean;
  is_link_question: boolean;
  is_answer_link_question: boolean;
  question_position: number;
  _destroy?: boolean;
  copy_idx?: number;
  questionnaire_answers: QuestionnaireAnswer[];
}

export interface IQuestionnaire {
  id?: number;
  title?: string;
  explanation?: string;
  start_time?: string;
  end_time?: any;
  is_draft?: boolean;
  created_at?: string;
  updated_at?: string;
  questionnaire_questions?: QuestionnairesQuestion[];
  delete_questions?: QuestionnairesQuestion[];
}

export interface QuestionnairesDetailResponse extends IResponse {
  result: {
    questionnaire: IQuestionnaire;
  };
}
